module.exports = __webpack_public_path__ + "img/copy-filled.f6db91b6.svg";